import { api } from '@/shared/api/axios.instance';
import { responseContract } from '@/shared/api/lib';
import type { AxiosRequestConfig } from 'axios';
import z from 'zod';

const _GetFacilityLevelsOfCareRatesAndRevenueRequestDtoSchema = z.object({
  /** Omit for the All Facilities view. */
  facilityId: z.number().optional(),
});

const GetFacilityLevelsOfCareRatesAndRevenueResponseDtoSchema = z.object({
  data: z.array(
    z.object({
      avgRate: z.number().nullable(),
      careLevel: z.string(),
      levelOfCare: z.number(),
      medianRate: z.number().nullable(),
      highestRate: z.object({
        fullName: z.string().nullable(),
        rate: z.number().nullable(),
        residentID: z.number().nullable(),
      }),
      lowestRate: z.object({
        fullName: z.string().nullable(),
        rate: z.number().nullable(),
        residentID: z.number().nullable(),
      }),
    })
  ),
});

export type GetFacilityLevelsOfCareRatesAndRevenueRequestDto = z.infer<
  typeof _GetFacilityLevelsOfCareRatesAndRevenueRequestDtoSchema
>;
export type GetFacilityLevelsOfCareRatesAndRevenueResponseDto = z.infer<
  typeof GetFacilityLevelsOfCareRatesAndRevenueResponseDtoSchema
>;

export const getFacilityLocRatesAndRevenue = (
  params: GetFacilityLevelsOfCareRatesAndRevenueRequestDto,
  config?: AxiosRequestConfig<GetFacilityLevelsOfCareRatesAndRevenueRequestDto>
) => {
  return api
    .get(
      params.facilityId !== undefined
        ? `facilities/${params.facilityId}/levels-of-care/rates-and-revenue`
        : 'facilities/levels-of-care/rates-and-revenue',
      { ...config }
    )
    .then(
      responseContract(GetFacilityLevelsOfCareRatesAndRevenueResponseDtoSchema)
    );
};
